import { List, Datagrid, TextField, EditButton, ShowButton, BooleanField, useRecordContext } from 'react-admin';
import {useEffect, useState} from "react";
import getDriverTypes from "../../actions/GetDriverTypes";

const UsersList = (props) => {
    const [driverTypeList, setDriverTypeList] = useState([{id: '', name: ''}]);
    useEffect(() => {
        getDriverTypes(props.adminMode).then((result => {
            setDriverTypeList(result);
        }))
    }, []);

    const DriverType = (props) => {
        const record = useRecordContext(props);
        let r = "";

        driverTypeList.forEach(item => {
            if (record.driverType === item.id) {
                r = item.name
            }
        });
        return <span>{r}</span>;
    }

    return (
        <List {...props}>
            <Datagrid currentSort={null}>
                <TextField source="id" label="Id"/>
                <TextField source="username" label="Username"/>
                <TextField source="password" label="Password"/>
                <TextField source="imei" label="IMEI"/>
                <TextField source="macAddress" label="MAC"/>
                <DriverType source="driverType" label="Driver Type"/>
                <BooleanField source="isActive" label="Active Status"/>
                <ShowButton />
                <EditButton />
            </Datagrid>
        </List>
    );
}

export default UsersList;